import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { SplitWrapperComponent } from '../split-wrapper/split-wrapper.component';
import { SplittableDynamicComponentConfig } from '../../model/splittable-dynamic-component-config';
import { SplitComponentService } from '../../services/split-component.service';

@Component({
    selector: 'app-split',
    imports: [SplitWrapperComponent],
    templateUrl: './split.component.html',
    styleUrl: './split.component.scss'
})
export class SplitComponent implements OnInit, OnDestroy {
  @Input() id: string;

  private splitComponentService = inject(SplitComponentService);

  public get dynamicComponents(): SplittableDynamicComponentConfig<any>[] {
    return this.splitComponentService.getComponentsConfigs(this.id);
  }

  ngOnDestroy(): void {
    this.splitComponentService.destroySplitter(this.id);
  }
  ngOnInit(): void {
    this.splitComponentService.initSplitter(this.id);
  }

  onClose(component: SplittableDynamicComponentConfig<any>) {
    this.splitComponentService.removeComponent(this.id, component.id);
  }
}
